import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger, DialogFooter, DialogClose } from "./dialog";
import { Button } from "./button";
import { Input } from "./input";
import { CopyIcon, XIcon } from "lucide-react";

const ShareLinkModal = ({ isOpen, onClose, shareUrl, onCopy }: any) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Share Tracking Link</DialogTitle>
          <DialogDescription>
            Copy the link below to share the tracking information.
          </DialogDescription>
        </DialogHeader>
        <div className="flex items-center space-x-2">
          <div className="grid flex-1 gap-2">
            <Input
              id="share-url"
              defaultValue={shareUrl}
              readOnly
              className="truncate"
            />
          </div>
          <Button type="button" onClick={onCopy} size="sm" className="px-3">
            <span className="sr-only">Copy</span>
            <CopyIcon className="h-4 w-4 mr-1" />
            Copy
          </Button>
        </div>
        <DialogFooter className="sm:justify-end">
            <DialogClose asChild>
                <Button type="button" variant="secondary" onClick={onClose}>
                    Close
                </Button>
            </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ShareLinkModal;